import axios from 'axios';
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';


export default async function DeleteRoutine(id, token) {
    
    const headers = { 'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`}
    try {
      const response = await axios.delete(`${BASE}/routines/${id}`, { headers : headers})
      
      return {response}
      
      
      
      
    } catch (error) {
      console.error(error);
    } 
}